import { Coffee } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { fetchSettings } from "@/lib/api";

export function DonationBox() {
  const { data: settings } = useQuery({
    queryKey: ["settings"],
    queryFn: fetchSettings,
  });

  const donationLink = settings?.donation_url;

  if (!donationLink) return null;

  const fullLink = donationLink.startsWith("http") ? donationLink : "https://" + donationLink;

  return (
    <div className="my-16 p-8 md:p-12 rounded-2xl bg-muted/30 border border-border/50 flex flex-col items-center text-center transition-colors">
      <div className="w-16 h-16 rounded-full bg-accent/10 flex items-center justify-center text-accent mb-6">
        <Coffee size={32} className=" " />
      </div>
      <h3 className="font-serif text-2xl font-medium mb-3">Dukung LiharAksara</h3>
      <p className="text-muted-foreground max-w-sm mb-8 leading-relaxed">
        Jika Anda menikmati tulisan ini, Anda dapat memberikan dukungan agar kami bisa terus
        menyajikan konten yang berkualitas.
      </p>
      <a
        href={fullLink}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2.5 px-8 py-3.5 bg-accent text-white rounded-full font-medium hover:opacity-90 transition-all shadow-lg shadow-accent/20"
      >
        <Coffee size={16} className=" " />
        <span>Beri Dukungan</span>
      </a>
      <p className="mt-6 text-[10px] uppercase tracking-widest text-muted-foreground font-bold">
        Terima kasih atas apresiasi Anda
      </p>
    </div>
  );
}
